export const CUTLERY_WIDGET_DATA_TEST_ID = {
    CONTAINER: "cutlery-opt-out-widget",
    NUDGE: "cutlery-opt-out-widget-nudge",
};
